
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { formatNumber } from "../../app/libs/misc";
import { RowData } from '@tanstack/react-table';

interface EditableCellProps<TData extends RowData, TValue> {
  getValue: () => TValue;
  row: { id: string; original: TData };
  column: { id: string };
  onUpdate: (rowId: string, columnId: string, value: TValue) => void;
}

const EditableCell = <TData extends RowData, TValue extends string | number>({
  getValue,
  row,
  column,
  onUpdate,
}: EditableCellProps<TData, TValue>) => {
  const initialValue = getValue();
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onBlur = () =>{
    if (value !== initialValue) {
      onUpdate(row.id, column.id, value);
    }
  }

  const onChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '') {
      setValue('' as TValue);
    } else {
      const parsed = parseFloat(inputValue.replace(/,/g, ''));
      setValue(isNaN(parsed) ? (inputValue as TValue) : (parsed as TValue));
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      (e.target as HTMLInputElement).blur(); // Blur on Enter to trigger onBlur
    }
  };
  
  return (
  <Form.Control
    type="text"
    size="sm"
    defaultValue={formatNumber(getValue())}
    onChange={(e) => onChange(e)}
    onBlur = {onBlur}
    onKeyDown={handleKeyDown}
  />)
}

export default EditableCell